<template>
    
  <footer class="container text-center py-4">
    <nav>
      <span style="padding-right: 5px;">이용안내 : 시스템 매뉴얼 반영</span>
      <div class="vr"></div>
      <span href="#" style="padding-left: 5px;padding-right: 5px;">고객센터 : eztobiz@mkiscore.com, 031-8009-0315</span>
      <div class="vr"></div>
      <a href="/privacy">개인정보보호정책</a>
      <div class="vr"></div>
      <a href="https://www.mkiscore.com/">회사소개</a>
    </nav>
    <div>copyright (c) allrights reserved.</div>
  </footer>

   
</template>
  
<script setup>
  import {onBeforeMount,onMounted,ref,reactive} from 'vue'

  const state = reactive({
    msg: 'Footer 컴포넌트',
  });
</script>
